import React from 'react';
import { Box, Flex, HStack, Text, keyframes } from '@chakra-ui/react';

/**
 * The three bouncing dots, in an incoming-style bubble.
 *
 * Shown for another AGENT typing in this thread — the only typing signal that
 * exists here (see hooks/useTyping). The name sits beside the dots so nobody
 * reads it as the customer.
 */
const bounce = keyframes`
	0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
	40% { transform: translateY(-4px); opacity: 1; }
`;

export default function TypingIndicator({ name }) {
	return (
		<Flex px="4" mt="2" align="flex-end">
			<Box
				bg="wa.incoming"
				borderRadius="7.5px"
				borderTopLeftRadius="0"
				px="3"
				py="2"
				boxShadow="0 1px 0.5px rgba(0,0,0,0.13)"
				aria-live="polite"
				aria-label={`${name} is typing`}
			>
				<HStack spacing="2" align="center">
					<HStack spacing="1" h="16px" align="center">
						{[0, 1, 2].map((i) => (
							<Box
								key={i}
								w="6px"
								h="6px"
								borderRadius="full"
								bg="wa.inkMuted"
								sx={{
									animation: `${bounce} 1.2s ${i * 0.15}s infinite ease-in-out`,
									'@media (prefers-reduced-motion: reduce)': { animation: 'none', opacity: 0.7 },
								}}
							/>
						))}
					</HStack>
					<Text fontSize="xs" color="wa.inkMuted">
						{name}
					</Text>
				</HStack>
			</Box>
		</Flex>
	);
}
